import React from "react";

export const initialModal = () => ({
  title: "Catch the Balls!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title"></div>
      <div className="modal-description-contents">
        <p>
          Drop up to 50 balls in 30 seconds. Tap anywhere to release a ball.
          Time it right and catch them in the moving buckets to score!
        </p>
      </div>
    </div>
  ),
  buttonText: "Start Game",
  buttonType: "start",
});

export const endGameModal = (score) => ({
  title: "Nice Try!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        You scored <strong>{score}</strong> points.
      </div>
      <div className="modal-description-contents">
        <p>Want to go again?</p>
      </div>
    </div>
  ),
  buttonText: "Play Again",
  buttonType: "start",
});
